import * as React from 'react';
import AuthService from 'services/Auth/AuthService';

import authService from '../../authContext';
import { ProviderProps } from 'react';

const AuthContext = React.createContext(authService);
const AuthProvider: React.FC<Partial<ProviderProps<AuthService>>> = props => {
    return <AuthContext.Provider value={authService} {...props} />;
};

const useAuth = () => {
    const authService: AuthService = React.useContext(AuthContext);

    // Initialize authService;
    React.useEffect(() => {
        authService.getSessionContext();
    }, [authService]);

    if (authService === undefined) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return authService;
};

export { AuthProvider, AuthContext, useAuth };
